import { QueryState } from 'common/enums';
import { Nullable } from 'common/utils/Nullable';
export interface IUpdateRequirementState {
  state: QueryState;
  error: Nullable<string>;
  accessToken: string | undefined;
}

export const UpdateRequirementEmptyState: IUpdateRequirementState = {
  state: QueryState.UNDEFINED,
  error: null,
  accessToken: undefined
};
